<template>
  <div class="tag-wrap2">
    <div class="tag-icon2-box">
      <img src="@/assets/icon-88.png" class="tag-icon2" alt="">
    </div>
    <ul class="tag-list2" :class="{'in-line': !showAllTags}">
      <li class="gray-tag" @click="show = true">
        +添加标签
      </li>
      <li v-for="(item, index) in tags" :key="index" @click="delTag(index)">
        {{ item }}
        <img src="@/assets/icon-90.png" alt="">
      </li>
    </ul>
    <div class="tag-icon3-box" :class="{'active': showAllTags}" @click="showAllTags = !showAllTags">
      <img src="@/assets/icon-89.png" class="tag-icon3" alt="">
    </div>

    <!-- 添加标签弹窗 -->
    <van-overlay :show="show" z-index="999">
      <div class="window-add">
        <span class="window-add-text">添加标签</span>
        <div class="window-add-input">
          <input type="text" placeholder="请输入标签" v-model="tag"/>
        </div>
        <div class="window-add-btn-box">
          <button type="button" class="cancel" @click="show = false">取消</button>
          <button type="button" class="confirm" @click="addTag()">确定</button>
        </div>
      </div>
    </van-overlay>
  </div>

</template>

<script>

import {Toast} from "vant";

export default {
  name: 'tags-edit',
  model: {
    prop: 'tags',
    event: 'tags'
  },
  props: {
    tags: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      show: false,
      showAllTags: false,
      tag: '',
    }
  },
  methods: {
    addTag() {
      if (this.tag.length === 0) {
        return Toast('请输入标签');
      }
      const tags = [...new Set([...this.tags, this.tag])];
      this.$emit('tags', tags);
      this.tag = '';
      this.show = false;
    },
    delTag(index) {
      const tags = [...this.tags];
      tags.splice(index, 1);
      this.$emit('tags', tags);
    },
  },
}
</script>

<style scoped>
.tag-wrap2 {
  width: 100%;
  display: flex;
  align-items: flex-start;
  padding-bottom: 1px;
  border-bottom: 1px solid #F3F3F3;
  box-sizing: border-box;
}

.tag-icon2-box {
  height: 26px;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  margin-right: 10px;
}

.tag-icon2 {
  height: 20px;
}

.tag-list2 {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
}

.tag-list2 > li {
  width: max-content!important;
  height: 26px;
  line-height: 26px;
  display: flex;
  align-items: center;
  background-color: #E6EDFF;
  border-radius: 30px;
  color: #2A63F3;
  font-weight: bold;
  margin-right: 10px;
  margin-bottom: 10px;
  font-size: 13px;
  padding: 0 12px;
}

.tag-list2 > li > img {
  width: 12px;
  margin-left: 7px;
}

.tag-list2.in-line{
  flex-shrink: 0;
  flex-wrap: nowrap;
  overflow-x: auto;
}

.tag-list2.in-line > li{
  flex-shrink: 0;
}

.gray-tag {
  background-color: #F3F3F3 !important;
  color: #7F7F7F !important;
  font-weight: normal !important;
}

.tag-icon3-box {
  height: 26px;
  display: flex;
  align-items: center;
  margin-left: 10px;
  margin-bottom: 10px;
}
.tag-icon3-box.active .tag-icon3{
  transform: rotate(180deg);
}

.tag-icon3 {
  width: 14px;
}

/* 添加标签弹窗 */
.window-add {
  width: calc(100% - 54px);
  padding: 20px 20px 29px;
  box-sizing: border-box;
  border-radius: 12px;
  background-color: #FFFFFF;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
}

.window-add-text {
  color: #222222;
  font-size: 18px;
  margin-bottom: 22px;
}

.window-add-input {
  width: 100%;
  height: 44px;
  background-color: #F3F3F3;
  border-radius: 10px;
  padding: 0 14px;
  box-sizing: border-box;
}

.window-add-input > input {
  flex: 1;
  height: 44px;
  font-size: 15px;
}

.window-add-input > input::placeholder {
  color: #A7A7A7;
}

.window-add-btn-box {
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 30px;
}

.window-add-btn-box > button {
  flex: 1;
  height: 30px;
  font-size: 18px;
  border-right: 1px solid #D8D8D8;
  box-sizing: border-box;
}

.window-add-btn-box > button:last-child {
  border-right: none;
}

.window-add-btn-box > button.confirm {
  color: #2A63F3;
}

.window-add-btn-box > button.cancel {
  color: #333333;
}
</style>
